import React, {useEffect} from "react";
import {Layout} from "antd";
import {Outlet, useNavigate, useMatch} from "react-router-dom";
import {useAppSelector} from "../../../store/app";
import HeaderPage from "../../../components/Header";
import FooterPage from "../../../components/Footer";
import ScrollToTop from "../../../utils/ScrollToTop";

const AuthLayout: React.FC = () => {
    const navigate = useNavigate();
    const token = useAppSelector((state) => state.auth.token);
    const IsAppSignUp = useMatch("/app-sign-up");
    const IsDeleteAccount = useMatch("/delete-account");
    let showHeaderFooter = true;
    if (IsAppSignUp || IsDeleteAccount) {
        showHeaderFooter = false;
    }

    useEffect(() => {
        if (token) {
            navigate("/");
        }
    }, [token, navigate]);

    return (
        <Layout className={`main__page__wrapper has__header`}>
            <ScrollToTop />
            {showHeaderFooter && <HeaderPage />}
            <Layout.Content className="main__page__content">
                <Outlet />
            </Layout.Content>
            {showHeaderFooter && <FooterPage />}
        </Layout>
    );
};

export default AuthLayout;
